export type Lang = 'vi' | 'tr' | 'pt' | 'id' | 'hi' | 'es' | 'en';

export const isLang = (lang: string | undefined): lang is Lang =>
	!!(
		lang === 'vi' ||
		lang === 'tr' ||
		lang === 'pt' ||
		lang === 'id' ||
		lang === 'hi' ||
		lang === 'es' ||
		lang === 'en'
	);
